
import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import * as SectionTemplateListAction from './action';
import { REPORT } from '../../../config';


export function* sectionTemplateList(action) {
    // let requestUrl = `${REPORT}/section/list`;
    let requestUrl = `${REPORT}/section/paged/${action.data.pageNumber}/${action.data.pageSize}/sort/${action.data.sortfield}/${action.data.sortDirection}`
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(SectionTemplateListAction.getSectionTemplateListSuccess(listResult));
    } catch (err) {
        yield put(SectionTemplateListAction.getSectionTemplateListFail(err))
    }
}
export function* getSectionTemplateList() {
    yield takeLatest(SectionTemplateListAction.SECTION_TEMPLATE_LIST, sectionTemplateList);
}

export function* masterDataKeyTemplate(action) {
    let requestUrl = `${REPORT}/section/mapping/bulk`;
    try {
        const listResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(SectionTemplateListAction.downloadMasterDataKeyTemplateSuccess(listResult.data));
    } catch (err) {
        yield put(SectionTemplateListAction.downloadMasterDataKeyTemplateFail(err.response))
    }
}
export function* downloadMasterDataKeyTemplate() {
    yield takeLatest(SectionTemplateListAction.DOWNLOAD_MASTER_DATA_KEY_TEMPLATE, masterDataKeyTemplate);
}

export function* bulkMasterDataKey(action) {
    let requestUrl = `${REPORT}/section/mapping/bulk`;
    try {
        const formData = new FormData();
        formData.append('file', action.data)
        const listResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(SectionTemplateListAction.uploadBulkMasterDataKeySuccess(listResult.data));
    } catch (err) {
        yield put(SectionTemplateListAction.uploadBulkMasterDataKeyFail(err.response))
    }
}
export function* uploadBulkMasterDataKey() {
    yield takeLatest(SectionTemplateListAction.UPLOAD_BULK_MASTER_DATA_KEY, bulkMasterDataKey);
}